var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgQuotesBoxDown = function SvgQuotesBoxDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 93,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.29 30.723v8.08l-6.026-.002 1.329-6.38H31.08V.002l30.208 30.722z",
    fill: "#FF8F8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 92.016h61.293V30.723H0v61.293z",
    fill: "#FF8F8F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.07 30.765l30.223.002-15.112-2.63-15.111-2.63v5.258z",
    fill: "#FF6161"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.566 76c-1.028 0-1.862-.09-2.505-.268l.309-5.868c3.082-.409 4.867-2.428 5.355-6.059H33.37L33.91 50h15.757l-.154 12.617c-.077 5.19-2.35 9.011-6.82 11.466C40.356 75.36 37.98 76 35.566 76zm-20.061 0c-1.028 0-1.863-.09-2.505-.268l.309-5.868c3.082-.409 4.867-2.428 5.355-6.059h-5.356L13.849 50h15.758l-.154 12.617c-.077 5.19-2.35 9.011-6.82 11.466C20.295 75.36 17.92 76 15.505 76z",
    fill: "#fff"
  })));
};
export default SvgQuotesBoxDown;